export const getUsers = (state) => state.users.users;
export const getUserContacts = (state) => state.users.userContact;
export const getUserPhoneForm = (state) => state.users.phoneForm;
export const getFilterValue = (state) => state.users.filterValue;
